<a eauEmptyLink class="eau-language-flag eau-language-flag--{{lang?.key}}"
    [class.eau-language-flag--active]="lang.isActive"
    title="{{lang.title | translate}}"
    *ngFor="let lang of languages; trackBy: trackByFn"
    (click)="onChooseLanguage(lang.key)">
</a>
